export const StoreState = {
    user:'user'
}

export const state = {
    [StoreState.user]:null
}
